export default function getSubdomain() {
  if (typeof window !== 'undefined') {
    const { hostname } = window.location;
    const parts = hostname.split('.');

    // if we are on local, we won't be able to parse a subdomain from the URL,
    // so instead, pull from an env variable
    if (hostname === 'localhost') {
      return process.env.GATSBY_TEST_MICROSITE_SUBDOMAIN || null;
    }

    if (parts.length >= 2) {
      // "staging" and "www" don't count as subdomains for our purposes
      if (parts[0] !== 'staging' && parts[0] !== 'www') {
        return parts[0];
      }
    }
  }
  return null;
}
